(() => {
  const PRODUCT_VARIANT_ID = 63126990225779;
  const SELECTOR = '[data-windproof-pricing]';

  const fabricRateIndex = {
    '5% Solar Screen': 0,
    '10% Solar Screen': 0,
    '30% Solar Screen': 0,
    '3% Openness': 1,
    'Full Blackout': 2,
    'Clear TPU 0.8mm': 3,
    'Serge Ferrari PES': 4,
  };

  const rateTables = {
    108: [
      { maxArea: 6, rates: [178, 203, 238, 238, 268] },
      { maxArea: 10, rates: [168, 193, 228, 228, 258] },
      { maxArea: Infinity, rates: [158, 183, 218, 218, 248] },
    ],
    130: [
      { maxArea: 8, rates: [198, 223, 258, 258, 288] },
      { maxArea: 10, rates: [178, 203, 238, 238, 268] },
      { maxArea: 12, rates: [168, 193, 228, 228, 258] },
      { maxArea: 14, rates: [158, 183, 218, 218, 248] },
      { maxArea: 16, rates: [148, 173, 208, 208, 238] },
      { maxArea: Infinity, rates: [138, 163, 198, 198, 228] },
    ],
  };

  const parseMeters = (value) => {
    const parsed = Number.parseFloat(String(value || '').replace(/[^\d.]/g, ''));
    return Number.isFinite(parsed) ? parsed : null;
  };

  const aspectSurcharge = (width, height) => {
    const ratio = Math.max(width, height) / Math.min(width, height);
    if (ratio > 4) return 68;
    if (ratio > 3) return 50;
    if (ratio > 2.5) return 35;
    if (ratio > 2) return 18;
    return 0;
  };

  const calculate = (width, height, fabric) => {
    if (!(fabric in fabricRateIndex)) return null;
    if (width < 0.7 || width > 6 || height < 0.7 || height > 5.6) return null;

    const cassette = width <= 4 && height <= 3 ? 108 : 130;
    const minimumArea = cassette === 108 ? 3 : 6;
    const billableArea = Math.max(width * height, minimumArea);
    const rateBand = rateTables[cassette].find(({ maxArea }) => billableArea <= maxArea);
    const rate = rateBand.rates[fabricRateIndex[fabric]];
    const surcharge = aspectSurcharge(width, height);
    const motor = 240;
    const remote = 35;
    const price = Math.ceil(billableArea * (rate + surcharge) + motor + remote);

    return {
      cassette,
      billableArea: Number(billableArea.toFixed(2)),
      rate,
      surcharge,
      price,
    };
  };

  const getOptionValue = (container, labels, fallbackId) => {
    const names = Array.isArray(labels) ? labels : [labels];
    const field =
      names.map((label) => container.querySelector(`[name="${CSS.escape(label)}"]`)).find(Boolean) ||
      container.querySelector(`#${CSS.escape(fallbackId)}`) ||
      container.querySelector(`[id^="${CSS.escape(fallbackId)}_"]`);

    if (!field) return '';
    if (field.matches('select, input:not([type="radio"]):not([type="checkbox"])')) {
      return field.value;
    }

    const selected =
      names
        .map((label) =>
          container.querySelector(`input[name="${CSS.escape(label)}"]:checked`),
        )
        .find(Boolean) ||
      container.querySelector(`input[id^="${CSS.escape(fallbackId)}_"]:checked`);
    return selected?.value || '';
  };

  const ensureProperty = (form, name) => {
    let input = form.querySelector(`input[name="properties[${name}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.disabled = false;
    return input;
  };

  const setAddonProperty = (form, result) => {
    const value = JSON.stringify([
      {
        i: PRODUCT_VARIANT_ID,
        q: 1,
        p: String(result.price),
        t: 'price',
      },
    ]);
    let input = form.querySelector('input[data-windproof-addon]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_gpo_addon_products]';
      input.dataset.windproofAddon = 'true';
      form.appendChild(input);
    }
    input.disabled = false;
    input.value = value;
    return value;
  };

  const setButtonState = (form, enabled) => {
    form.querySelectorAll('button[name="add"], button[type="submit"]').forEach((button) => {
      if (button.closest('.shopify-payment-button')) return;
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', String(!enabled));
    });
  };

  const initialize = () => {
    const pricing = document.querySelector(SELECTOR);
    const container = document.querySelector('.gpo-container');
    const form = container?.closest('form[action*="/cart/add"]');
    if (!pricing || !container || !form || form.dataset.windproofPricingReady === 'true') {
      return false;
    }

    form.dataset.windproofPricingReady = 'true';
    const priceValue = pricing.querySelector('[data-windproof-price-value]');
    const systemValue = pricing.querySelector('[data-windproof-system]');
    const statusValue = pricing.querySelector('[data-windproof-price-status]');
    let currentResult = null;
    let currentOptions = null;
    const productGroup = String(Date.now());

    const update = () => {
      const width = parseMeters(getOptionValue(container, ['Width (m)', 'Width'], 'dropdown-1'));
      const height = parseMeters(
        getOptionValue(container, ['Height (m)', 'Height'], 'dropdown-2'),
      );
      const fabric = getOptionValue(container, 'Fabric', 'buttons-1');
      const result = width && height && fabric ? calculate(width, height, fabric) : null;

      if (!result) {
        currentResult = null;
        currentOptions = null;
        priceValue.textContent = 'Select width, height and fabric';
        systemValue.textContent = '';
        statusValue.textContent = 'Your configured price will appear here.';
        setButtonState(form, false);
        return null;
      }

      currentResult = result;
      currentOptions = {
        _has_gpo: '1605192',
        Width: `${width.toFixed(1)} m`,
        Height: `${height.toFixed(1)} m`,
        Fabric: fabric,
      };
      priceValue.textContent = `$${result.price.toLocaleString('en-US')}`;
      systemValue.textContent = `${result.cassette} mm cassette · ${result.billableArea} m² billable area`;
      statusValue.textContent =
        result.surcharge > 0
          ? `Includes $${result.surcharge}/m² aspect-ratio surcharge, standard motor and remote.`
          : 'Includes the selected fabric, standard motor and single-channel remote.';

      setAddonProperty(form, result);
      ensureProperty(form, '_gpo_options').value = JSON.stringify(currentOptions);
      ensureProperty(form, '_gpo_product_group').value = productGroup;
      ensureProperty(form, 'Cassette').value = `${result.cassette} mm`;
      ensureProperty(form, 'Billable Area').value = `${result.billableArea} m²`;
      ensureProperty(form, 'Configured Price').value = `$${result.price}`;
      setButtonState(form, true);
      return result;
    };

    container.addEventListener('change', () => window.setTimeout(update, 0));
    container.addEventListener('input', () => window.setTimeout(update, 0));
    container.addEventListener('click', () => window.setTimeout(update, 0));
    form.addEventListener(
      'submit',
      (event) => {
        const result = update();
        if (!result) {
          event.preventDefault();
          event.stopImmediatePropagation();
          statusValue.textContent = 'Please select width, height and fabric before adding to cart.';
        }
      },
      true,
    );
    form.addEventListener('formdata', (event) => {
      if (!currentResult) return;
      event.formData.delete('properties[_gpo_addon_products]');
      event.formData.set(
        'properties[_gpo_addon_products]',
        setAddonProperty(form, currentResult),
      );
      event.formData.set('properties[_gpo_options]', JSON.stringify(currentOptions));
      event.formData.set('properties[_gpo_product_group]', productGroup);
    });

    update();
    return true;
  };

  const boot = () => {
    if (initialize()) return;
    const observer = new MutationObserver(() => {
      if (initialize()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
